import { toast } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import { useDispatch } from 'modules/react-redux';
import { useCallback } from 'react';
import { ToggleXeroBudgetsSync, useToggleXeroBudgetsSync } from 'shared/data/webApp/v1';

import { updateBudgetSyncSetting } from '../actions';
import { messages } from '../messages';
import { useSyncXeroBudgetsMutation } from './useSyncXeroBudgetsMutation';

export const useToggleXeroBudgetsSyncMutation = (companyId: string) => {
    const { mutate, isLoading, isSuccess } = useToggleXeroBudgetsSync();
    const { syncXeroBudgets } = useSyncXeroBudgetsMutation();
    const dispatch = useDispatch();

    const toggleXeroBudgetsSync = useCallback(
        (data: ToggleXeroBudgetsSync['body'], integrationType: domain.IntegrationType) => {
            mutate(
                { body: data },
                {
                    onSuccess: () => {
                        dispatch(updateBudgetSyncSetting(data));

                        const integrationName = selectors.integration.getIntegrationTypeName(integrationType);

                        toast.success(
                            data.isEnabled
                                ? messages.syncEnabled({ integrationName })
                                : messages.syncDisabled({ integrationName })
                        );

                        if (data.isEnabled) {
                            syncXeroBudgets({ companyId }, integrationType);
                        }
                    },
                }
            );
        },
        [companyId, dispatch, mutate, syncXeroBudgets]
    );

    return {
        toggleXeroBudgetsSync,
        isLoadingToggleXeroBudgetsSync: isLoading,
        isSuccessToggleXeroBudgetsSync: isSuccess,
    };
};
